import { render, staticRenderFns } from "./AutoResponseManager.vue?vue&type=template&id=c60370f8&"
import script from "./AutoResponseManager.vue?vue&type=script&lang=js&"
export * from "./AutoResponseManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports